import { render, staticRenderFns } from "./duoLandingPage.vue?vue&type=template&id=7d991e09&scoped=true&"
import script from "./duoLandingPage.vue?vue&type=script&lang=js&"
export * from "./duoLandingPage.vue?vue&type=script&lang=js&"
import style0 from "./duoLandingPage.vue?vue&type=style&index=0&id=7d991e09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d991e09",
  null
  
)

export default component.exports